import React, { useState } from 'react';
import { getGlobalData, isHauptadmin } from '../../lib/globalData';
import { useTranslate, useRecordContext, List, Create, Edit, Datagrid, SimpleForm, 
  TextField, ReferenceField, 
  EditButton, TextInput, Filter, BooleanInput, ReferenceInput, SelectInput } from 'react-admin';
import Move from '../../lib/Move';
import BooleanRedField from '../../fields/BooleanRedField';
import CloseToolbar from '../../lib/CloseToolbar';
import NoPagination from '../../lib/NoPagination';
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";

const JsonChipField = ({dispSource, sx}) => {
  const record = useRecordContext();
  if (!record) return null;
  if(record.has_modifier===false)return null

  const value = record[dispSource];
  if (!value) return null;

  var items = {}
  try {
    items = JSON.parse(value);
  }
  catch {
    console.log("json corrupt")
  }
  if(typeof items !== 'object')return null
  return (
    <Stack label={dispSource} sx={sx}>
      {Object.entries(items).map(([key, item]) => (
        <Chip key={record+'cf'+key} label={key+': '+item} size="small" />
      ))}
    </Stack>
  )
}

const ConditionalReferenceField = ({dispSource}) => {
  const record = useRecordContext();
  if (!record) return null;
  if(record.has_modifier===false)return null
  const value = record[dispSource];
  if (!value) return null;
  return (
    <ReferenceField source={dispSource} reference="setAgecategory">
      <TextField source="bezeichnung" />
    </ReferenceField>
  )
}

const ListForm = (props) => {
  const [moveStart, setMoveStart] = useState(0);
  const getMoveStart = () => {
    return moveStart;
  }
  const {classes, ...rest} = props;
  const bwh_sprachen = getGlobalData('info').bwh_sprachen;
  return (
    <List {...rest} title="bw.set.agecategory.title" sort={{ field: 'pos', order: 'ASC' }} 
      exporter={isHauptadmin() && props.exporter} pagination={<NoPagination />} perPage={1000} >
      <Datagrid style={{ width: 'auto' }} bulkActionButtons={false}>
        <TextField source="pos" textAlign="right" />
        <Move label="glob.move" getMoveStart={getMoveStart} setMoveStart={setMoveStart} endpoint="setAgecategory" />
        <TextField source="bezeichnung" />
        <ConditionalReferenceField dispSource="id_parent" />
        <TextField source="abk" />
        <JsonChipField dispSource="preis_modifier" />
        {bwh_sprachen.map((sp)=>(<BooleanRedField label={sp.toUpperCase()} source={"complete_" + sp} sortable={false} key={sp} />))}
{isHauptadmin() &&
        <TextField source="id" textAlign="right" />
}
        <EditButton label="" />
      </Datagrid>
    </List>
  )
}

const CEForm = ({classes, hasList, hasEdit, hasCreate, hasShow, ...props}) => {
  const translate = useTranslate();
  const rec = useRecordContext()
  const bwh_sprachen = getGlobalData('info').bwh_sprachen;
  return (
    <SimpleForm toolbar={<CloseToolbar />} {...props}> 
        <TextInput source="bezeichnung" />
        <TextInput source="abk" />
      {bwh_sprachen.map((sp)=>(
        <TextInput fullWidth source={"description_" + sp} label={translate("bw.set.agecategory.description") + ' ' + sp} />
      ))}
      {isHauptadmin() ?
        <>
          <ReferenceInput source="id_parent" reference="setAgecategory" filter={{ child : rec?.id??0 }} >
            <SelectInput optionText="bezeichnung" />
          </ReferenceInput>
          <TextInput source="preis_modifier" />
        </>
        :
        <>{ (rec?.id_parent || rec?.preis_modifier) && <>
          <div style={{color: 'grey'}}>{translate('resources.setAgecategory.fields.id_parent')}</div>
          <ReferenceField source="id_parent" reference="setAgecategory">
            <TextField source="bezeichnung" />
          </ReferenceField>
          <div style={{marginTop: '1em', color: 'grey'}}>{translate('resources.setAgecategory.fields.preis_modifier')}</div>
          <JsonChipField source="preis_modifier" sx={{mb: '1em'}} />
        </>}</>
      }
        <p fullWidth>{translate("bw.set.agecategory.help")}</p>
        <p fullWidth>{translate("bw.set.agecategory.help2")}</p>
    </SimpleForm>
  )
};

const ListFilter = (props) => (
    <Filter {...props}>
        <TextInput source="bezeichnung" alwaysOn inputProps={{ 'data-lpignore': 'true', autoComplete: 'off' }} />
        <TextInput source="abk" alwaysOn inputProps={{ 'data-lpignore': 'true', autoComplete: 'off' }} />
        <BooleanInput source="showall" label="bw.set.agecategory.showdel" alwaysOn />
    </Filter>
);

const Agecategory =  {
  list: ({ classes, ...props }) => (
    <ListForm {...props} classes={classes} filters={<ListFilter />} />
  ),
  
  create: ({classes, ...props }) => (
    <Create {...props} title="bw.set.agecategory.titleCreate" redirect="list">
      <CEForm {...props} classes={classes} />
    </Create>
  ),
  
  edit: ({ classes, ...props }) => (
    <Edit title="bw.set.agecategory.titleEdit" mutationMode="pessimistic" {...props}>
      <CEForm {...props} classes={classes} />
    </Edit>
  )
}   
export default Agecategory